export default __webpack_public_path__ + "static/media/DOCTORCERTIFICATEFOR5DISEASES_BLANK.f9a09afa.png";